// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m0-0";
export var fileList = "_m0-2";
export var removeFileButton = "_m0-1";